<template>
    <main class="p-6">
      <h1>Company Detail (temporary)</h1>
      <p>Company ID: <strong>{{ companyId }}</strong></p>
      <ul>
        <li><router-link :to="`/watch/seed/example-seed`">Open example seed</router-link></li>
        <li><router-link to="/watch">Back to Watch Dashboard</router-link></li>
      </ul>
    </main>
  </template>
  
  <script>
  export default {
    name: "CompanyDetail",
    props: {
      companyId: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  